import React from 'react'
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import HRAgentResume from '../../components/hr-agent/HRAgentResume';
import Banner from '../../components/hr-agent/Banner';
import HRAgentInterview from '../../components/hr-agent/HRAgentInterview';
import HrAgentFooter from '../../components/hr-agent/HRAgentFooter';

const HRAgent = () => {
  return (
    <>
      <SEO
				title="Jobseeker"
				description=""
			/>
			{/* <Layout> */}
        <Banner />
        <HRAgentResume />
        <HRAgentInterview />
        <HrAgentFooter />
			{/* </Layout> */}
    </>
  )
}

export default HRAgent;